import { render, staticRenderFns } from "./ConsentRegisterModal.vue?vue&type=template&id=42c2e112&scoped=true&"
import script from "./ConsentRegisterModal.vue?vue&type=script&lang=js&"
export * from "./ConsentRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsentRegisterModal.vue?vue&type=style&index=0&id=42c2e112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2e112",
  null
  
)

export default component.exports